import { axiosInstance } from "@/config/axiosInstance";

// ? Login Super Admin Action
export const loginSuperAdmin = (data: { email: string; password: string }) =>
  axiosInstance
    .post("/super/login", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

// ? Create New Admin Action

export const createNewAdmin = (superAdminKey: string) => (data: object) =>
  axiosInstance
    .post("/admin/register", data, {
      headers: {
        authorization: `Bearer ${superAdminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

// ? Edit Admin Action

export const editAdmin =
  (superAdminKey: string) => (data: { adminId: string; postData: object }) =>
    axiosInstance
      .post(`/admin/edit/${data.adminId}`, data.postData, {
        headers: {
          authorization: `Bearer ${superAdminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Create Admin Activity Action
export const createAdminActivity =
  () => (data: { admin: string; mode: string }) =>
    axiosInstance
      .post(`/admin/activity`, data, {
        headers: {
          // authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Update Check-in Time Action
export const updateCheckinTime =
  (superAdminKey: string) =>
  (data: { checkinId: string; newTime: string; isLate?: boolean; reason: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        message?: string;
        checkin?: {
          _id: string;
          mode: string;
          oldTime: string | Date;
          newTime: string | Date;
          employee: {
            _id: string;
            name: string;
            email: string;
          };
        };
      }>(
        `/super/checkins/update/${data.checkinId}`,
        { newTime: data.newTime, isLate: data.isLate, reason: data.reason },
        {
          headers: {
            authorization: `Bearer ${superAdminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Assign Employees to Admin
export const assignEmployeesToAdmin =
  (superAdminKey: string) =>
  (data: { adminId: string; employeeIds: string[] }) =>
    axiosInstance
      .post(`/super/assign-employees`, data, {
        headers: {
          authorization: `Bearer ${superAdminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Unassign Employees
export const unassignEmployees =
  (superAdminKey: string) => (data: { employeeIds: string[] }) =>
    axiosInstance
      .post(`/super/unassign-employees`, data, {
        headers: {
          authorization: `Bearer ${superAdminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
